export function formatRentalTerm(rentalTerm: string | string[]) {
    if (rentalTerm === 'short') {
        return 'Short lets';
    }

    return '';
}
